<template>
  <div class="sn-head-photo" v-if="photo">
    <img :style="pattern" :src="photo" @load="handle" @error="handle">
  </div>
</template>
<script>
import * as Constants from '@/common/utils/constants.js';

export default {
  name: 'sn-head-photo',
  props: {
    src: {
      type: String,
      required: true,
      default: Constants.INITIAL_DOCTOR_PHOTO
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    shape: {
      type: String,
      default: 'square'
    },
    radius: {
      type: Number,
      default: 0
    }
  },
  computed: {
    pattern() {
      const initial = {
        '--width': 'auto',
        '--height': 'auto',
        '--radius': '0px'
      };
      if (this.$sn.validate.empty(this.width)) {
        if (this.$sn.validate.empty(this.height)) initial['--width'] = '80px';
      }
      else initial['--width'] = this.width + 'px';
      if (!this.$sn.validate.empty(this.height)) initial['--height'] = this.height + 'px';
      if (this.shape === 'circle' && this.$sn.validate.empty(this.radius)) initial['--radius'] = this.radius + 'px';
      return initial;
    }
  },
  watch: {
    src: {
      handler: function(value) {
        this.photo = '';
        setTimeout(() => {
          this.photo = value || this.perpetual.INITIAL_DOCTOR_PHOTO;
        }, 100);
      },
      immediate: true
    }
  },
  data() {
    return {
      perpetual: Constants,
      photo: ''
    };
  },
  methods: {
    handle(e) {
      if (e.type === 'error') this.photo = this.perpetual.INITIAL_DOCTOR_PHOTO;
    }
  }
};
</script>
<style lang="scss">
.sn-head-photo {
  overflow: hidden;
  width: max-content;
  height: max-content;

  img {
    display: block;
    width: var(--width);
    height: var(--height);
    border-radius: var(--radius);
  }
}
</style>
